import axios, { AxiosResponse } from "axios";
import ServerResult from "../../models/dtos/base/ServerResult";
import { SignInDTO } from "../../models/dtos/identity/SignInDTO";
import { StudentInitialRegistrationDTO } from "../../models/dtos/identity/StudentInitialRegistrationDTO";
import { TokenView } from "../../models/views/identity/TokenView";
import BaseService from "../base/BaseService";

export default class AuthenticationService extends BaseService {
    anotherSignIn(userId: string): Promise<any> {
        return axios.post(`/Authentication/AnotherSignIn?userID=${userId}`)
            .then(function (response: AxiosResponse<any, any>) {
                return response;
            });
    }

    signIn(signInDTO: SignInDTO): Promise<ServerResult<TokenView>> {
        return axios.post(`/Authentication/SignIn`, signInDTO)
            .then(function (response: AxiosResponse<ServerResult<TokenView>, any>) {
                return response.data;
            });
    }

    getUserIsRegister(userName: string): Promise<ServerResult<boolean>> {
        return axios.get(`/Authentication/GetUserIsRegister?userName=${userName}`)
            .then(function (response: AxiosResponse<ServerResult<boolean>, any>) {
                return response.data;
            });
    }

    sendOTPByUserName(userName: string): Promise<ServerResult<string>> {
        return axios.get(`/Authentication/SendOTPByUserName?userName=${userName}`)
            .then(function (response: AxiosResponse<ServerResult<string>, any>) {
                return response.data;
            });
    }

    refreshToken(refreshToken: string): Promise<ServerResult<string>> {
        return axios.post(`/Authentication/RefreshToken?refreshToken=${refreshToken}`)
            .then(function (response: AxiosResponse<ServerResult<string>, any>) {
                return response.data;
            });
    }

    resetPass23(userName: string): Promise<ServerResult<string>> {
        return axios.post(`/Authentication/ResetPass23?userName=${userName}`)
            .then(function (response: AxiosResponse<ServerResult<string>, any>) {
                return response.data;
            });
    }

    registerStudent(registerUserDTO: StudentInitialRegistrationDTO): Promise<any> {
        return axios.post(`/Authentication/StudentInitialRegistration`, registerUserDTO)
            .then(function (response: any) {
                if (response == undefined) return false
                return true;
            }).catch(response => {
                return false;
            });
    }
}